var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormatStrikethroughOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11H5C4.45614 11 4 11.4561 4 12C4 12.5439 4.45614 13 5 13H19C19.5439 13 20 12.5439 20 12C20 11.4561 19.5439 11 19 11ZM16.7719 6.36842C15.5789 4.92982 13.8772 4 12 4C9.2807 4 7 5.96491 7 8.49123C7 9.03509 7.45614 9.49123 8 9.49123C8.54386 9.49123 9 9.03509 9 8.49123C9 7.01754 10.1579 6 12 6C13.3158 6 14.3333 6.5614 15.2281 7.63158C15.4211 7.85965 15.6842 8 16 8C16.5439 8 17 7.54386 17 7C17 6.75439 16.9123 6.54386 16.7719 6.36842ZM15 15.4912C15 16.9825 13.8421 18 12 18C10.6842 18 9.66667 17.4386 8.77193 16.3684C8.57895 16.1404 8.31579 16 8 16C7.45614 16 7 16.4561 7 17C7 17.2456 7.08772 17.4561 7.22807 17.6316C8.42105 19.0702 10.1228 20 12 20C14.7193 20 17 18.0351 17 15.4912C17 14.9474 16.5439 14.4912 16 14.4912C15.4561 14.4912 15 14.9474 15 15.4912Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatStrikethroughOutlined);
export default __webpack_public_path__ + "static/media/format_strikethrough_outlined.fc95f8d3.svg";
export { ForwardRef as ReactComponent };